import React from "react";
import "./Header.css";
import CTA from "./CTA";
import Typical from "react-typical";
//import Option from "../Option"
import ME from "../asserts/nira.jfif";
import HeaderSocials from "./HeaderSocials";
import TopHeader from "../TopHeader";

const Header = () => {
  return ( <div>
     
    <TopHeader/>
    <header>
    
      <div className="container header-container">
        <h5>Hello I,m</h5>
        <span className= "highlighted-text">NIRAJ KUMAR</span>
        <div className='profile-detail-role'>
              <span className='primary-text'>{" "}
                <h1>{" "}<Typical loop ={Infinity} steps ={["NIRAJ KUMAR 😎", 1000,
              
              " Full stack Developer 💻", 1000,"Backend developer ", 1000,"MERN stack Dev 📱", 1000,"Fronted developer", 1000
              
              
              
              
              ]}/>





                </h1>
                <span className='profile-role-tagline'>knack of building application with front and back end operations</span>

                
                </span>
                </div>
      
        <CTA />
        <HeaderSocials />
        <div className="me">
          <img src={ME} alt="Niraj" />
        </div>
        <a href="#contact" className="scroll-down">
          Scroll Down
        </a>
      </div>
    </header>
    </div>
  );
};

export default Header;